// extracted by mini-css-extract-plugin
export default {"button":"MenuToggle_button__JWYr0","buttonWithIcon":"MenuToggle_buttonWithIcon__3+dFn","menuBurger":"MenuToggle_menuBurger__WEVls","hiddenBurger":"MenuToggle_hiddenBurger__OKu1i"};